/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RunType, RunStatus } from 'models/viewModels';

export const getRunStatusLabel = (runStatus: RunStatus = RunStatus.UNKNOWN_RUN_STATUS): string => {
  switch (runStatus) {
    case RunStatus.COMPLETED:
      return 'Completed';
    case RunStatus.LIVE:
      return 'Live';
    case RunStatus.UNAVAILABLE:
      return 'Upcoming';
    case RunStatus.CANCELED:
      return 'Canceled';
    case RunStatus.REPLAY_ENABLED:
      return 'Replay Enabled';
    default:
      return 'Unknown';
  }
};

export const getRunTypeLabel = (runType: RunType = RunType.UNKNOWNRUNTYPE): string => {
  switch (runType) {
    case RunType.PRACTICE:
      return 'Practice';
    case RunType.QUALIFYING:
      return 'Qualifying';
    case RunType.RACE:
      return 'Race';
    case RunType.TEST_EVENT:
      return 'Test';
    default:
      return 'Unknown';
  }
};